import { render, staticRenderFns } from "./ChineseReport.vue?vue&type=template&id=04d77444&scoped=true&"
import script from "./ChineseReport.vue?vue&type=script&lang=js&"
export * from "./ChineseReport.vue?vue&type=script&lang=js&"
import style0 from "./ChineseReport.vue?vue&type=style&index=0&id=04d77444&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d77444",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VFlex,
  VLayout,
})
